import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "surface", "operation"]

  connect() {
    const requestedSurface = new URLSearchParams(window.location.search).get("surface")

    if (requestedSurface && Array.from(this.surfaceTarget.options).some((option) => option.value === requestedSurface)) {
      this.surfaceTarget.value = requestedSurface
      this.filter()
    }
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    const surface = this.surfaceTarget.value

    this.operationTargets.forEach((operation) => {
      const matchesQuery = query === "" || operation.dataset.name.includes(query)
      const filters = operation.dataset.filters.split("|")
      const matchesSurface = surface === "" || filters.includes(surface)
      operation.hidden = !(matchesQuery && matchesSurface)
    })
  }
}
